import angular from 'angular';
import SsoAuthorizationService from './ssoAuthorization.service';
import ssoComponent from './sso.component';

let ssoModule = angular.module('sso', [])
  .component('sso', ssoComponent)
  .service('SsoAuthorizationService', SsoAuthorizationService);

export default ssoModule;



// WEBPACK FOOTER //
// ./app/common/sso/sso.js